module.exports = __webpack_public_path__ + "static/media/2-1.3687a6a3.png";